module.exports = __webpack_public_path__ + "img/PULSIVE VENTIL ROOF 1S.e4e7fad6.jpg";